import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MembershipOptionStore, MembershipOptionState } from './membership-option.store';
import { PaymentOptionType } from './models/payment-option-type';

@Injectable({ providedIn: 'root' })
export class MembershipOptionQuery extends QueryEntity<MembershipOptionState> {

  constructor(protected store: MembershipOptionStore) {
    super(store);
  }

  selectPaid() {
    return this.selectAll({ filterBy: option => option.PaymentType === PaymentOptionType.Paid });
  }
}
